import React from 'react';
import { Redirect } from 'react-router-dom';
import { Formik } from 'formik';
import { useRouter } from 'modules/shared/hooks';
import { SubmitButton, PageTitle } from 'modules/shared-ui/components';
import { InputControl, PasswordInputControl } from 'modules/shared-form/components';

import { LoginFormProps, LoginProps } from './login-form-type';

import styles from './login-form-component.module.css';

export const LoginForm: React.FC<LoginFormProps> = ({
    model,
    onSuccess,
    isAuthenticated,
    redirectPath,
    errorMessage,
}: LoginFormProps) => {
    const { location } = useRouter();

    if (isAuthenticated) {
        let url = redirectPath;
        if (!url) {
            url = location.pathname;
            let lastSlash = url.lastIndexOf('/');
            lastSlash = lastSlash === -1 ? url.length : lastSlash + 1;
            url = url.substring(0, lastSlash);
        }

        return <Redirect to={url} />;
    }

    return (
        <React.Fragment>
            <div className={styles.loginForm}>
                <div className={styles.title}>
                    <PageTitle title="DÉJÀ INSCRIT / DÉJÀ CLIENT" uppercase centered />
                    <p>J’accède à mon espace personnel pour gérer ma liste</p>
                </div>

                <Formik<LoginProps>
                    initialValues={model}
                    onSubmit={updatedModel => onSuccess(updatedModel)}
                    render={props => (
                        <form onSubmit={props.handleSubmit} className={styles.form}>
                            <div className={styles.formContainer}>
                                <div className={styles.formColumn}>
                                    <div className={styles.formLine}>
                                        <InputControl
                                            name="folderIdOrEmail"
                                            required
                                            placeholder="MON N° DE DOSSIER / EMAIL"
                                        />
                                    </div>
                                    <div className={styles.formLine}>
                                        <PasswordInputControl name="password" placeholder="MON MOT DE PASSE" disablePattern={true} required />
                                    </div>
                                    <div className={styles.linkContainer}>
                                        <a href="/mot-de-passe-oublie" className={styles.link}>
                                            Mot de passe oublié
                                        </a>
                                    </div>
                                    <div className={styles.loginBtn}>
                                        <SubmitButton text="Connexion" />
                                    </div>
                                </div>
                            </div>
                            {errorMessage && <span className={styles.submitError}>{errorMessage}</span>}
                        </form>
                    )}
                />
            </div>
        </React.Fragment>
    );
};
